"use strict";

var _this = this;
var curryN = require('./curryN');
/**
 * Takes two functions, tryer and catcher.
 *
 * Returns a function that, when invoked with zero or more parameters,
 * calls the tryer with those parameters, and if tryer throws,
 * calls the catcher with the error as first argument and original arguments as rest.
 * If that still throws, then ¯\_(ツ)_/¯
 *
 * @param {Function} tryer
 * @param {Function} catcher
 * @return {Function}
 * @example
 *      tryCatch(x => x.length, () => 0)([ 1, 2, 3 ]) // 3
 *      tryCatch(x => x.length, () => 0)( undefined ) // 0
 *      tryCatch(
 *          someDataTransform,
 *          (err, ...rest) => {
 *              logAsyncToServer('someDataTransform failed', err, 'with arguments', rest);
 *              return DEFAULT_VALUE;
 *          }
 *      )( someIncompleteData ) // DEFAULT_VALUE (error is logged somewhere)
 */
module.exports = curryN(2, function (tryer, catcher) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    try {
      return tryer.apply(_this, args);
    } catch (e) {
      args.unshift(e);
      return catcher.apply(_this, args);
    }
  };
});